<template>
  <v-container class="pa-0">
    <v-row no-gutters class="px-8 text-grey text-body-1" style="opacity: 0.55"
      >New plants</v-row
    >

    <div class="container-columns px-6 pt-2" style="min-height: 240px">
      <transition-group name="move-left">
        <Plant
          @toggleLove="toggleLove"
          v-for="(plant, index) in activities"
          :key="index"
          :plant="plant"
          :self="self"
        />
        <div
          key="trigger"
          class="d-inline-block"
          v-intersect.quiet="onIntersect"
        ></div>
        <div
          v-for="n in 3"
          :key="n + 'skeleton'"
          class="d-inline-block"
          style="height: 250px"
        >
          <v-skeleton-loader
            type="image"
            class="rounded-xl mr-4"
            height="200"
            width="160"
          ></v-skeleton-loader>
        </div>
      </transition-group>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Plant from "@/components/activity/Plant.vue";

export default {
  name: "PlantsActivity",
  components: {
    Plant,
  },
  mounted() {
    this.$store.dispatch("activities/getFirstActivities");
  },
  computed: {
    ...mapState("activities", ["activities", "activitiesPending"]),
    ...mapState("self", ["self"]),
  },
  methods: {
    toggleLove(params, plant) {
      let newPlant = plant;
      if (newPlant.loversId.includes(this.self.id)) {
        newPlant.loversId = newPlant.loversId.filter((i) => {
          return i !== this.self.id;
        });
      } else {
        newPlant.loversId.push(this.self.id);
      }
      //   this.$store.dispatch("level/updateLevel", {
      //     field: "plant",
      //     value: true,
      //   });
      this.$store.commit("plants/updatePlant", newPlant);
      this.$store.dispatch("lovers/toggleLove", params);
    },
    onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.$store.dispatch("activities/getNextActivities");
      }
    },
  },
};
</script>

<style >
.container-columns {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.container-columns::-webkit-scrollbar {
  height: 10px;

  color: var(--v-primary-base) !important;
}
.container-columns::-webkit-scrollbar-track {
  border-radius: 10px;
  margin-left: 30px;
  margin-right: 30px;
}
.container-columns::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(194, 194, 194, 0.2);
}

.move-left-item {
  transition: all 0.5s;
}
.move-left-enter,
.move-left-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
.move-left-leave-active {
  position: absolute;
  z-index: -1;
}
</style>